import { ref } from 'vue';

export function useCardTabNavigation() {
    const activeSyncId = ref<string | null>(null);

    function setActiveSyncId(syncId: string) {
        activeSyncId.value = syncId;
    }

    return {
        activeSyncId,
        setActiveSyncId,
    };
}
